import PropTypes from 'prop-types';
import React from 'react';

import MixedCopy from '../../molecules/mixed-copy/mixedCopy';
import StyledTextarea from './textarea.style';

const Textarea = ({
  className,
  name,
  label,
  description,
  required = false,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  active,
  warning,
  error = false,
  disabled = false
}) => (
  <StyledTextarea className={className} error={error} disabled={disabled} active={active}>
    <label htmlFor={label} className="textarea__wrapper">
      <div className="textarea__label">
        {required && <span className="textarea__required">*</span>}
        {label}
      </div>
      <textarea
        id={label}
        name={name}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        aria-required={required}
        aria-invalid={error}
        disabled={disabled}
      />
    </label>

    {warning && (
      <span className="textarea__warn" aria-hidden={!error}>
        {warning}
      </span>
    )}

    {description && <MixedCopy html={description} fullWidth className="textarea__desc" />}
  </StyledTextarea>
);

Textarea.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  active: PropTypes.bool.isRequired,
  warning: PropTypes.shape(),
  error: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Textarea;
